export default __webpack_public_path__ + "static/media/play-circle.168a9195.svg";